
import { default as axios, AxiosResponse } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { State } from 'vuex-class';
import BarometerCollection from '../../components/overview/BarometerCollection.vue';
import Dashboard from '../../components/overview/Dashboard.vue';
import { IMemberWithoutBarometerHypermediaRepresentation } from '../../shared/contracts/MemberContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { performance } from '../../shared/services/PerformanceService';
import { IAggregateState } from '../../store/contract';
import store from '../../store/store';
const aggregateNamespace = 'aggregate';

@Component({
    components: {
        Dashboard,
        BarometerCollection
    }
})
export default class MyOverview extends Vue {
    @State(aggregateNamespace) aggregateState: IAggregateState;

    private actionSnapshots: ISnapshotHypermediaRepresentation[] = [];
    protected areActionsLoading: boolean = false;
    private membersWithoutBarometer: IMemberWithoutBarometerHypermediaRepresentation[] = [];
    protected areMembersLoading: boolean = false;
    private loadedActions = false;

    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track('My dashboard');
        await store.dispatch('aggregate/fetchRecentAggregate');
        await store.dispatch('aggregate/fetchAllAggregate');
        next();
    }

    created() {
        this.retrieveMembersWithoutBarometer();
        this.retrieveActionSnapshots();
    }

    protected retrieveActionSnapshots() {
        this.areActionsLoading = true;
        return axios
            .get(this.aggregateState.allAggregateItem._links.item_people_actions.href)
            .then((response: AxiosResponse<ISnapshotHypermediaRepresentation[]>) => {
                this.loadedActions = true;
                this.actionSnapshots = response.data;
                this.areActionsLoading = false;
            });
    }

    protected retrieveMembersWithoutBarometer() {
        const link = this.aggregateState.allAggregateItem._links.item_members_without_barometer;
        if (link && link.href) {
          this.areMembersLoading = true;
          return axios
                .get(link.href)
                .then((response: AxiosResponse<IMemberWithoutBarometerHypermediaRepresentation[]>) => {
                    this.membersWithoutBarometer = response.data;
                    this.areMembersLoading = false;
                })
                .catch(() => {
                    this.membersWithoutBarometer = [];
                    this.areMembersLoading = false;
                });
        }
        return Promise.resolve();
    }

    protected dashboardLoaded() {
        if (this.loadedActions) {
            this.$nextTick(() => {
                performance.end('My dashboard');
            });
        }
    }
}
